import React, { useState, useEffect, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import ItemsPerPageDropdown from 'components/ItemsPerPageDropdown'
import Pagination from 'features/Pagination'
import Loader from 'components/Loader'
import ViewIcon from 'assets/icons/view-site-icon'
import AddIcon from 'assets/icons/bold-add-new'
import SpeciesStateForm from 'flow/SiteMonitoring/pages/State/CreateEvaluation/SpeciesStateForm'
import AddStateEvaluationModal from 'flow/SiteMonitoring/pages/State/CreateEvaluation/AddStateEvaluationModal'
import CheckboxArrowIcon from 'assets/icons/checkbox-left-arrow'
import Checkbox from 'components/Checkbox'
import { MonitoringContext } from 'providers/monitoring'
import CircleIcon from 'assets/icons/circle-icon'
import {
  BiodiversitySelectorWrapper,
  SelectAllContainer,
  ActionButton,
  ViewButton,
  ButtonContent,
  IconSlot,
  TextSlot,
  ItemWrapper,
  PaginationWrapper,
  TabsWrapper,
  Tab,
  GlobalSelectAll
} from './style'

const BiodiversitySelector = ({
  items = [],
  handleSelectAll,
  handleToggleClass,
  isClassSelected,
  isClassDisabled,
  onFilterChange,
  globalSelectAll,
  setGlobalSelectAll,
  isGlobalSelectDisabled,
  onActionClick,
  onViewMonitoring,
  isLoadingEvaluations,
  selected,
  isSlectedAll,
  handleToggle,
  isEditable,
  clearAllSelections,
  totalBenchmarks,
  isAllAdded,
  pagination
}) => {
  const { biodiversityFilter } = useContext(MonitoringContext)
  const [actionLoading, setActionLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [evaluationId, setEvaluationId] = useState(null)
  const filteredItems = items.filter((item) => {
    if (biodiversityFilter === 1) return item.type === 'Species'
    if (biodiversityFilter === 2) return item.type === 'Ecosystem'
    return true
  })

  // grouped species by classname
  const groupedItems = filteredItems.reduce((acc, item) => {
    if (item.type === 'Species') {
      const groupKey = item.className || 'OTHERS'
      if (!acc[groupKey]) acc[groupKey] = []
      acc[groupKey].push(item)
    } else {
      // ecosystem using flat list
      if (!acc[item.id]) acc[item.id] = []
      acc[item.id].push(item)
    }
    return acc
  }, {})

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  const handleEvaluationIdUpdate = (id) => {
    setEvaluationId(id)
    if (selectedItem) {
      setSelectedItem((prev) => (prev ? { ...prev, evaluationId: id } : prev))
    }
  }

  const handleTypeChange = (selectedOption) => {
    const value = typeof selectedOption === 'number' ? selectedOption : (selectedOption?.value ?? 1)

    onFilterChange?.(value)
  }

 
  const renderItemRow = (item) => {
    const triggerStateEvalId = item?.raw?.triggerStateBenchmark?.[0]?.trigger_state_evaluation?.[0]?.id ?? null
    const evalId = triggerStateEvalId
    const triggerBenchmark = Array.isArray(item?.raw?.triggerStateBenchmark) ? item.raw.triggerStateBenchmark[0] : null
    const finalEvaluationId = evalId || triggerBenchmark?.id || null
    const hasTrigger = Boolean(triggerBenchmark)
    const hasEvaluation = triggerBenchmark?.is_added === true
    const isEvaluated = Boolean(finalEvaluationId)
    const statusClass = hasTrigger && hasEvaluation ? 'green' : hasTrigger ? 'blue' : 'grey'
    return (
      <ItemWrapper key={item.id} className="tree-child">
        <div className="item-left">
          {biodiversityFilter === 1 && (
            <span style={{ marginBottom: '5px' }}>
              <CheckboxArrowIcon />
            </span>
          )}
          <Checkbox
            checked={selected.includes(item.raw.historyId || item.id) || item.raw.isChecked}
            onChange={(e) => {
              e?.stopPropagation && e.stopPropagation()
              e?.preventDefault && e.preventDefault()
              handleToggle(item)
            }}
            disabled={item.raw.isChecked || !isEditable}
            label= {
              <div className="item-info">
             <span><CircleIcon /></span>
            <div className="item-name">
              <span>
                <i>{item.name}</i>
              </span>
              {item.species && <span> {item.species}</span>}
              {item.season && <span>{`(${item.season.charAt(0).toUpperCase() + item.season.slice(1)})`}</span>}
            </div>
          </div>
            }
          />

          
        </div>
      </ItemWrapper>
    )
  }

  const handleActionClick = async () => {
    try {
      setActionLoading(true)
      await onActionClick?.(selected, isSlectedAll, biodiversityFilter, globalSelectAll)
    } finally {
      setActionLoading(false)
    }
  }

  const handleViewMonitoringClick = async () => {
    try {
      setActionLoading(true)
      await onViewMonitoring?.()
    } finally {
      setActionLoading(false)
    }
  }

  const selectableItems = filteredItems.filter((it) => !it.raw?.isChecked)

  return (
    <Container>
      <Row>
        <Col md={8} mdOffset={2}>
          <BiodiversitySelectorWrapper>
            {isLoadingEvaluations ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '300px'
                }}
              >
                <Loader />
              </div>
            ) : (
              <>
                <TabsWrapper>
                  <Tab className={biodiversityFilter === 1 ? 'active' : ''} onClick={() => handleTypeChange(1)}>
                    <FormattedMessage id="species" />
                    {biodiversityFilter === 1 && (
                      <>
                        {globalSelectAll
                          ? ` | ${pagination?.totalNumber} selected`
                          : selected.length > 0
                            ? ` | ${selected.length} selected`
                            : ''}
                      </>
                    )}
                  </Tab>

                  <Tab className={biodiversityFilter === 2 ? 'active' : ''} onClick={() => handleTypeChange(2)}>
                    <FormattedMessage id="ecosystem" />
                    {biodiversityFilter === 2 && (
                      <>
                        {globalSelectAll
                          ? ` | ${pagination?.totalNumber} selected`
                          : selected.length > 0
                            ? ` | ${selected.length} selected`
                            : ''}
                      </>
                    )}
                  </Tab>
                </TabsWrapper>

                {filteredItems.length > 0 && (
                  <SelectAllContainer>
                    <label>
                      <Checkbox
                        checked={isSlectedAll}
                        onChange={(e) => {
                          e?.stopPropagation?.()
                          e?.preventDefault?.()
                          handleSelectAll({ target: { checked: !isSlectedAll } })
                        }}
                        disabled={selectableItems.length === 0 || !isEditable}
                        label = {
                           <div className="item-info">
                        <FormattedMessage id="selectState" />
                      </div>
                        }
                      />
                     
                    </label>

                    {(isSlectedAll || globalSelectAll) &&
                      pagination.totalNumber > pagination.resultsPerPage &&
                      !(pagination.totalNumber === totalBenchmarks) && (
                        <GlobalSelectAll
                          className={isGlobalSelectDisabled ? 'disabled' : ''}
                          onClick={() => {
                            if (isGlobalSelectDisabled) return

                            setGlobalSelectAll((prev) => {
                              const next = !prev
                              if (!next) {
                                handleSelectAll({ target: { checked: false } })
                                clearAllSelections()
                              }

                              return next
                            })
                          }}
                        >
                          {globalSelectAll
                            ? 'Clear all selection'
                            : `Select all ${pagination.totalNumber} ${
                                biodiversityFilter === 1 ? 'species' : 'ecosystems'
                              }`}
                        </GlobalSelectAll>
                      )}

                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '12px' }}>
                      <ActionButton
                        onClick={handleActionClick}
                        disabled={
                          !items.length || actionLoading || !isEditable || (!globalSelectAll && selected.length === 0)
                        }
                      >
                        <ButtonContent>
                          <IconSlot>{actionLoading ? <Loader size={23} /> : <AddIcon />}</IconSlot>

                          <TextSlot>
                            {actionLoading ? (
                              <FormattedMessage id="creating" />
                            ) : biodiversityFilter === 1 ? (
                              <FormattedMessage id="createStateEvaluation" />
                            ) : (
                              <FormattedMessage id="createStateEvaluationEcosystem" />
                            )}
                          </TextSlot>
                        </ButtonContent>
                      </ActionButton>

                      <ViewButton onClick={handleViewMonitoringClick} disabled={!items.length || actionLoading}>
                        <ButtonContent>
                          <IconSlot>
                            <ViewIcon />
                          </IconSlot>
                          <TextSlot>
                            <FormattedMessage id="viewStateEvaluation" />
                          </TextSlot>
                        </ButtonContent>
                      </ViewButton>
                    </div>
                  </SelectAllContainer>
                )}

                {isAllAdded === true && (
                  <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '24px' }}>
                    <ViewButton onClick={handleViewMonitoringClick} disabled={actionLoading}>
                      <ButtonContent>
                        <IconSlot>
                          <ViewIcon />
                        </IconSlot>
                        <TextSlot>
                          <FormattedMessage id="viewStateEvaluation" />
                        </TextSlot>
                      </ButtonContent>
                    </ViewButton>
                  </div>
                )}

                {filteredItems.length === 0 && (
                  <div className="no-records-text" style={{ textAlign: 'center', padding: '32px', color: '#333333' }}>
                    {totalBenchmarks > 0 ? (
                      <FormattedMessage id={biodiversityFilter === 1 ? 'allSpeciesAdded' : 'allEcosystemsAdded'} />
                    ) : (
                      <FormattedMessage id="noRecordsFound" />
                    )}
                  </div>
                )}
                <>
                  {biodiversityFilter === 1 && //species grouped
                    Object.entries(groupedItems).map(([groupName, groupItems]) => (
                      <div key={groupName}>
                        <ItemWrapper className="group-row">
                          <div className="item-left">
                            <Checkbox
                              checked={isClassSelected(groupName)}
                              disabled={isClassDisabled(groupName) || !isEditable}
                              onChange={(e) => {
                                e?.stopPropagation?.()
                                e?.preventDefault?.()
                                handleToggleClass(groupName, !isClassSelected(groupName))
                              }}
                              label = { 
                                <div className="item-info">
                                  <span className="item-group-name">{groupName}</span>
                                </div>
                              }
                            />{' '}
                          
                          </div>
                        </ItemWrapper>

                        {groupItems.map((item) => renderItemRow(item))}
                      </div>
                    ))}

                  {biodiversityFilter === 2 && // ecosystem list
                    filteredItems.map((item) => renderItemRow(item))}
                </>

                {filteredItems.length > 0 && (
                  <PaginationWrapper>
                    <ItemsPerPageDropdown
                      currentPage={pagination.currentPage}
                      resultsPerPage={pagination.resultsPerPage}
                      totalNumber={pagination.totalNumber}
                      onChange={pagination.onChange}
                      // menuPlacement="top"
                    />
                    {pagination.totalPages > 1 && (
                      <Pagination
                        activePages={pagination.currentPage}
                        numberOfPages={pagination.totalPages}
                        nextPage={pagination.nextPage}
                        prevPage={pagination.prevPage}
                        selectPage={pagination.selectPage}
                      />
                    )}
                  </PaginationWrapper>
                )}
              </>
            )}
          </BiodiversitySelectorWrapper>
        </Col>
      </Row>

      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 50,
            left: 0,
            width: '100%',
            display: 'flex',
            minHeight: '90vh',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
            background: '#fff'
          }}
        >
          <AddStateEvaluationModal modalTitleId="modalTitle" autoSaveIcon={true} onClose={closeModal}>
            <SpeciesStateForm
              triggerItem={selectedItem}
              fieldItem={items}
              onCancel={closeModal}
              evaluationId={evaluationId}
              onEvaluationCreated={handleEvaluationIdUpdate}
            />
          </AddStateEvaluationModal>
        </div>
      )}
    </Container>
  )
}

export default BiodiversitySelector
